export default "__VITE_ASSET__BvbVyH9s__"